<template>
  <div id="app">
    <Header />
    <router-view id="maincontent" />
    <Footer />
    <a href="javascript:void(0)" class="scroll-top off">
      <span class="screen-reader-text">{{ $t("button.goToTop") }}</span>
    </a>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  watch: {
    $route: {
      handler() {
        this.$nextTick(() => {
          // console.log(document.getElementById("maincontent"));
          const header = document.getElementsByTagName("header")[0]
            .offsetHeight;
          const footer = document.getElementsByTagName("footer")[0]
            .offsetHeight;
          document.getElementById(
            "maincontent"
          ).style.minHeight = `calc(100vh - ${header + footer + 7}px)`;
        });
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
iframe {
  max-width: 100%;
}
.toasted-container {
  &.top-right {
    right: 0 !important;
    .toasted {
      background-color: #2ba048;
      width: 100%;
      padding: 15px;
    }
  }
}
</style>
